// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"5c6ee378","498":"358c9cb6","513":"58663143","787":"0d080fac"}[chunkId] + ".chunk.js";
};